import React from 'react';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { Card, Row, Col } from "antd";
import fileUtils from "../../utils/file-utils";
import { groupType } from "../../constants/app-constants";
import * as Icon from "react-feather";

const { Meta } = Card;

function getValue(groupValue,value){
    switch (groupValue) {
        case groupType.BANNER: return value.bannerId;
        case groupType.SERVICE_LINK: return value.serviceLinkId;
        case groupType.HIGHLIGHT_BOX: return value.highlightBoxId;
        case groupType.FOOTER_LINK: return value.footerLinkId;
        default: return null;
    }
}

const RemoveButton = ({removeDisplay, displayId}) => {
    return(
        <button
              style={{
                position: 'absolute',
                backgroundColor: '#f5f5f5',
                border: '0px',
                top: '0px',
                right: '0px',
                fontSize: '18px',
                color: '#b3b3b3',
                cursor: 'pointer',
              }}
              onClick={() => removeDisplay(displayId)}>
              x
        </button>
    )
};

/**
 * NMU-439: a banner arranged here but switched Offline in the table below can
 * never reach the website — the public API only serves published banners. Left
 * unmarked the card looks exactly like a live one, so the admin sees a banner
 * "on display" that the site never shows, which is the mismatch this ticket is
 * about. Banners only: the other card types have no status column.
 */
const OfflineTag = () => (
  <span
    style={{
      display: 'inline-block',
      marginTop: '6px',
      padding: '1px 8px',
      borderRadius: '10px',
      backgroundColor: '#f5f5f5',
      border: '1px solid #d9d9d9',
      color: '#8c8c8c',
      fontSize: '12px',
    }}
  >
    Offline — ไม่แสดงบนเว็บไซต์
  </span>
);

const SortableItem = SortableElement(({value, onRemove, groupValue}) => {

  const {attachImage, title, status } = value;
  const id = getValue(groupValue, value);

  const renderDetail = ()=> {
    switch (groupValue) {

      case groupType.BANNER:
        return (
          <Card
            hoverable
            className="w-100"
            cover={<img  src={fileUtils.getFileRenderUrl(
            groupValue,
            id,
            attachImage.originalFilename
            )} />}
          >
            <RemoveButton removeDisplay={onRemove} displayId={id}></RemoveButton>
            <Meta title={title} />
            {status === false && <OfflineTag />}
          </Card>
        )

      case groupType.HIGHLIGHT_BOX:
        return (
          <Card bordered={false} className="w-100 card-highlight text-center pb-0" >
            <div className="circle-icon text-center">
            <img  src={fileUtils.getFileRenderUrl(
                groupValue,
                id,
                attachImage.originalFilename
                )} />
            </div>
            <RemoveButton removeDisplay={onRemove} displayId={id}></RemoveButton>
            <p className="mb-0">{title.titleTH}</p>
          </Card>
        )
      case groupType.FOOTER_LINK:
        return (
          <Card bordered={false} className="w-100 card-highlight text-center pb-0 mb-4" >
            <div className="circle-icon text-center">
              <Icon.Link size={20} color='white' />
            </div>
            <RemoveButton removeDisplay={onRemove} displayId={id}></RemoveButton>
            <p className="mb-0">{title.titleTH}</p>
          </Card>
        )
      default:
        return (
          <Card
            hoverable
            className="w-100"
            cover={<img  src={fileUtils.getFileRenderUrl(
            groupValue,
            id,
            attachImage.originalFilename
            )} />}
          >
            <RemoveButton removeDisplay={onRemove} displayId={id}></RemoveButton>
            <Meta title={title} />
          </Card>
        )
    }
  }

  return (
      <Col span={6} key={id}>
        {renderDetail()}
      </Col>
  );
});

const SortableList = SortableContainer(({ items, onRemove, groupValue }) => {
  return (
    <Row gutter={30}>
      {items.map((value, index) => (
        <SortableItem
          key={`sortable-${getValue(groupValue, value)}`}
          index={index}
          value={value}
          onRemove={onRemove}
          groupValue={groupValue}
        />
      ))}
    </Row>
  );
});

export default SortableList;